export default "<app-main-nav-bar [navigationItems$]=\"navigationItems$\"></app-main-nav-bar>\r\n";